import React from 'react';

import Checkmark from '../../../../common/img/components/Checkmark';

import styles from './LicensedContentPriceBox.module.scss';

const LicensedContentPriceBox = () => {
  const { articleLicensingPriceInDollars } = window.articleLicensing;
  const features = [
    'Utilize our award-winning journalism to reinforce message for your target market',
    'Obtain licensing right to drive engagement with our original content',
    'Downloadable Word document with permission to print and share',
  ];
  return (
    <aside className={styles.priceBox} aria-labelledby="priceBox__heading">
      <div className={styles.priceBox__header}>
        <span className={styles.priceBox__price}>${articleLicensingPriceInDollars}</span>
        <span className={styles.priceBox__quantifier}>per article</span>
      </div>
      <p className={styles.priceBox__description}>
        Why license content with Industry Dive?
      </p>
      <ul className={styles.priceBox__features}>
        {features.map((feature, index) => (
          <li key={index}>  {/* eslint-disable-line react/no-array-index-key */}
            <Checkmark /> <span>{feature}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default LicensedContentPriceBox;
